define(["require", "exports", "jquery", "./analytics", "./context", "./colorTable", "./addressBar"], function (require, exports, $, analytics_1, context_1, colorTable_1, addressBar_1) {
    "use strict";
    exports.__esModule = true;
    function isRadioOption(x) {
        return x && x.type === 'radio';
    }
    var AssetFilter = (function () {
        function AssetFilter(id, name, prefix, options, hidden, renderClassName) {
            if (hidden === void 0) { hidden = false; }
            if (renderClassName === void 0) { renderClassName = undefined; }
            this.id = id;
            this.name = name;
            this.prefix = prefix;
            this.options = options;
            this.hidden = hidden;
            this.renderClassName = renderClassName;
        }
        AssetFilter.prototype.render = function ($container) {
            var _this = this;
            var label = this.name ? "<label for=\"" + this.id + "\">" + this.name + ":</label>" : '';
            var $filter = $("<div class='" + (this.hidden ? 'hidden' : '') + "'>" + label + "<div id=\"" + this.id + "\"></div></div>");
            $container.replaceWith($filter);
            var $select = $filter.find("#" + this.id);
            this.options.forEach(function (option, index) {
                var val;
                var name;
                var renderAs;
                var type = 'checkbox';
                if (typeof option === 'object') {
                    name = option.name;
                    val = option.val || name;
                    renderAs = option.renderAs || name;
                    if (isRadioOption(option)) {
                        type = option.type;
                    }
                }
                else {
                    val = option;
                    name = option;
                    renderAs = option;
                }
                $select.append("<div><input type=\"" + type + "\" value=\"" + val + "\" id=\"" + _this.prefix + "_" + _this.id + "_" + index + "\" name=\"" + _this.id + "\"/><label class=\"checkbox-button\" for=\"" + _this.prefix + "_" + _this.id + "_" + index + "\" title=\"" + name + "\">" + renderAs + "</label></div>");
            });
            return $filter;
        };
        AssetFilter.prototype.shouldUpdateQuery = function () {
            return this.options.reduce(function (cur, option) {
                if (cur) {
                    return cur;
                }
                if (typeof option === 'object' && !isRadioOption(option)) {
                    return option.updateQuery;
                }
                return false;
            }, false);
        };
        AssetFilter.prototype.valuesToQuery = function () {
            return $("#" + this.id).find('input:checked').map(function (i, x) { return $(x).val(); }).toArray().join(',');
        };
        AssetFilter.prototype.valuesFromQuery = function () {
            if (!this.shouldUpdateQuery()) {
                return [];
            }
            var data = addressBar_1.getAttributesFromHash();
            var values = (data[this.id] || "").split(',').filter(function (x) { return !!x; });
            return values;
        };
        return AssetFilter;
    }());
    var mockTags = [
        'red,silk,floral',
        'green,cotton,solid',
        'blue,silk,pattern'
    ];
    var AssetFilterProvider = (function () {
        function AssetFilterProvider($dlg, filters, options) {
            var _this = this;
            this.$dlg = $dlg;
            this.filters = filters;
            this.options = options;
            this.$filter = this.$dlg.find('.open-filter');
            this.$clear = this.$dlg.find('.clear-filter');
            this.$done = this.$dlg.find('.apply-filter');
            this.$counter = this.$dlg.find('.filter-count');
            this.settings = {};
            var $container = (options.$assetContainer || $dlg);
            this.totalCount = $container.find(this.options.sel).length;
            this.currentCount = this.totalCount;
            if (!this.$clear.length) {
                this.$clear = $container.find('.clear-filter');
            }
            this.$filter.click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                analytics_1["default"]('filter', 'open');
                _this.openFilters();
                _this.ensureFilters();
            });
            this.$done.click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                analytics_1["default"]('filter', 'close');
                _this.closeFilters();
            });
            this.$clear.click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                analytics_1["default"]('filter', 'clear');
                _this.clearFilters();
                _this.syncFilterSettings();
                _this.applyFilters();
            });
            this.$counter.text(this.totalCount + " options");
            if (context_1["default"].isMobile()) {
                var $closer = $dlg.find('.panel-close-button');
                var $filters = $dlg.find('.asset-filters');
                $filters.appendTo($closer.closest('.panel-header'));
            }
            this.$dlg.data('filterProvider', this);
        }
        AssetFilterProvider.prototype.populateFilterChoices = function () {
            var _this = this;
            $.each(this.settings, function (key) {
                var vals = _this.settings[key];
                _this.$dlg.find(".asset-filters .filter-choices #" + key + " input").each(function (i, input) {
                    $(input).prop('checked', vals.indexOf($(input).val()) >= 0);
                });
            });
        };
        AssetFilterProvider.prototype.ensureFilters = function () {
            var _this = this;
            var choices = this.$dlg.find('.filter-choices');
            var shouldApplyFilters = false;
            this.filters.forEach(function (filter) {
                var _a;
                _this.settings[filter.id] = _this.settings[filter.id] || [];
                if (!_this.$dlg.find("#" + filter.id).length) {
                    if (!filter.renderClassName) {
                        choices.append(filter.render($("<div></div>")));
                    }
                    else {
                        var $container = _this.options.$assetContainer || _this.$dlg;
                        $container.find(filter.renderClassName).append(filter.render($("<div></div>")));
                    }
                }
                if (filter.shouldUpdateQuery()) {
                    var filterValues = filter.valuesFromQuery();
                    shouldApplyFilters = shouldApplyFilters || filterValues.length > 0;
                    (_a = _this.settings[filter.id]).push.apply(_a, filterValues);
                }
            });
            this.populateFilterChoices();
            var handleChange = function (e) {
                var _a;
                _this.syncFilterSettings();
                var $cur = $(e.currentTarget);
                var filterName = $cur.attr('name');
                analytics_1["default"]('filter', 'apply', filterName);
                var filter = _this.filters.filter(function (x) { return x.id === filterName; })[0];
                if (filter && filter.shouldUpdateQuery()) {
                    addressBar_1.setHashFromData((_a = {}, _a[filterName] = filter.valuesToQuery(), _a));
                }
                _this.applyFilters();
            };
            choices.on('change', 'input[type="checkbox"], input[type="radio"]', null, handleChange);
            this.filters.filter(function (f) { return f.renderClassName; }).forEach(function (f) {
                $(f.renderClassName).on('change', 'input[type="checkbox"], input[type="radio"]', null, handleChange);
            });
            if (shouldApplyFilters) {
                this.applyFilters();
            }
        };
        AssetFilterProvider.prototype.closeFilters = function () {
            var $filters = this.$dlg.find('.asset-filters');
            $filters.toggleClass('open', false);
            $filters.closest('.customDesignFabric').find('#matchingFabricApplication').toggleClass('hidden', false);
            this.$dlg.find('.filter-choices').hide();
            this.toggleFilterOpen(false);
        };
        AssetFilterProvider.prototype.toggleFilterOpen = function (open) {
            if (this.options.$filerStatus) {
                this.options.$filerStatus.toggleClass('filters-open', open);
            }
            else if (context_1["default"].isMobile()) {
                this.$filter.closest('.panel-close, .panel-header').toggleClass('filters-open', open);
            }
            else {
                this.$dlg.find('.asset-filters').toggleClass('filters-open', open);
            }
        };
        AssetFilterProvider.prototype.openFilters = function () {
            var $filters = this.$dlg.find('.asset-filters');
            $filters.toggleClass('open', true);
            $filters.closest('.customDesignFabric').find('#matchingFabricApplication').toggleClass('hidden', true);
            this.$dlg.find('.filter-choices').show();
            this.toggleFilterOpen(true);
        };
        AssetFilterProvider.prototype.syncFilterSettings = function () {
            var _this = this;
            $.each(this.filters, function (i, filter) {
                var id = filter.id;
                var $container = filter.renderClassName ? (_this.options.$assetContainer || _this.$dlg) : _this.$dlg;
                _this.settings[id] = $.makeArray($container
                    .find("#" + id + " input[type]:checked")
                    .map(function (i, chk) { return $(chk).val(); }));
            });
        };
        AssetFilterProvider.prototype.clearFilters = function () {
            var _this = this;
            $.each(this.settings, function (key) {
                if (key !== 'grade') {
                    _this.settings[key] = [];
                }
            });
            var $filters = this.$dlg.find(".filter-choices div[id]" + (this.options.clearsInvisible ? '' : ':visible') + " input[type]");
            $filters.each(function (i, chk) {
                $(chk).prop('checked', false);
            });
            this.$clear.prop('disabled', 'disabled');
        };
        AssetFilterProvider.prototype.applyFilters = function () {
            var count = applyAssetFilters(this.$dlg, this.settings, this.options);
            this.setCurrentCount(count);
            if (this.options.$filerStatus) {
                this.options.$filerStatus.toggleClass('filter-in-effect', this.totalCount > count);
            }
            if (this.currentCount < this.totalCount) {
                this.$clear.removeProp('disabled');
            }
        };
        AssetFilterProvider.prototype.setCurrentCount = function (count) {
            this.currentCount = count;
            if (this.currentCount == 0) {
                this.$counter.text('No option found');
            }
            else if (this.currentCount < this.totalCount) {
                this.$counter.text(this.currentCount + " of " + this.totalCount + " options");
            }
            else {
                this.$counter.text(this.totalCount + " options");
            }
        };
        AssetFilterProvider.prototype.setFilterChoices = function (settings) {
            this.settings = settings;
            this.populateFilterChoices();
        };
        return AssetFilterProvider;
    }());
    exports.AssetFilterProvider = AssetFilterProvider;
    function asLookup(set) {
        return set.reduce(function (cur, k) {
            cur[k] = true;
            return cur;
        }, {});
    }
    exports.asLookup = asLookup;
    function overlaps(set1, set2) {
        return intersects(set1, asLookup(set2));
    }
    exports.overlaps = overlaps;
    function intersects(tags, filters) {
        if (!filters) {
            return true;
        }
        var result = false;
        for (var i in tags) {
            if (filters[tags[i]]) {
                return true;
            }
        }
        return false;
    }
    function colorBlock(color) {
        return "<div style=\"background-color:" + color + "\" class=\"color-block\"></div>";
    }
    function setupFilter($dlg, options) {
        var provider = new AssetFilterProvider($dlg, [
            new AssetFilter('color', 'Color', options.choiceIdPrefix, [
                { name: 'pink', renderAs: colorBlock(colorTable_1["default"].pink) },
                { name: 'red', renderAs: colorBlock(colorTable_1["default"].red) },
                { name: 'orange', renderAs: colorBlock(colorTable_1["default"].orange) },
                { name: 'gold', renderAs: colorBlock(colorTable_1["default"].gold) },
                { name: 'yellow', renderAs: colorBlock(colorTable_1["default"].yellow) },
                { name: 'green', renderAs: colorBlock(colorTable_1["default"].green) },
                { name: 'blue', renderAs: colorBlock(colorTable_1["default"].blue) },
                { name: 'purple', renderAs: colorBlock(colorTable_1["default"].purple) },
                { name: 'white', renderAs: colorBlock(colorTable_1["default"].white) },
                { name: 'beige', renderAs: colorBlock(colorTable_1["default"].beige) },
                { name: 'grey', renderAs: colorBlock(colorTable_1["default"].grey) },
                { name: 'black', renderAs: colorBlock(colorTable_1["default"].black) },
            ]),
            new AssetFilter('material', 'Material', options.choiceIdPrefix, ['cotton', 'polyester', 'faux silk', 'silk'].map(function (x) { return ({ name: x, val: x, updateQuery: true }); })),
            new AssetFilter('pattern', 'Pattern', options.choiceIdPrefix, ['solid', 'pattern']),
            new AssetFilter('grade', 'Grade', options.choiceIdPrefix, ['1', '2', '3', '4', '5'], true),
            new AssetFilter('sort', null, options.choiceIdPrefix, [
                { type: 'radio', name: 'low to high', val: 'asc', renderAs: "<p>$&ndash;$$$</p>" },
                { type: 'radio', name: 'high to low', val: 'desc', renderAs: "<p>$$$&ndash;$</p>" }
            ], false, '.price-filter')
        ], options);
        if (options.ensureFilterChoices) {
            provider.ensureFilters();
        }
        $dlg.data('filter-setup', true);
    }
    exports.setupFilter = setupFilter;
    function applyAssetFilters($dlg, settings, options) {
        var sel = options.sel;
        var $container = (options.$assetContainer || $dlg);
        var $imgAssets = $container.find(sel);
        var getAssetId = options.getAssetId;
        var getGrade = options.getAssetGrade;
        $.each(settings, function (key, filters) {
            if (key === 'sort') {
                return;
            }
            var filterMap = {};
            if (filters && filters.length) {
                $.each(filters, function (i, filter) { filterMap[filter] = true; });
            }
            else {
                filterMap = null;
            }
            if (key === 'grade') {
                var grades_1 = settings['grade'];
                $imgAssets = $imgAssets.filter(function (i, img) {
                    var grade = getGrade($(img));
                    return !grade || !grades_1.length || grades_1.indexOf("" + grade) >= 0;
                });
            }
            else {
                $imgAssets = $imgAssets.filter(function (i, img) {
                    var tags = $(img).data('tags');
                    if (tags === undefined) {
                        tags = mockTags[parseInt($(img).data('asset_id')) % mockTags.length];
                    }
                    return intersects(tags ? tags.split(',') : [], filterMap);
                });
            }
        });
        var assetIds = {};
        $.each($imgAssets, function (i, img) {
            assetIds[getAssetId($(img))] = true;
        });
        var sorting = settings.sort;
        if (sorting && sorting.length === 1) {
            var sortBy_1 = sorting[0];
            var sortedAssets = $.makeArray($container.find(sel)).sort(function (f1, f2) {
                var grade1 = Number(getGrade($(f1)));
                var grade2 = Number(getGrade($(f2)));
                return sortBy_1 === 'asc' ? grade1 - grade2 : grade2 - grade1;
            });
            var sortedBoxes = sortedAssets.map(function (x) { return options.getSortedBox(x); });
            var $list = options.getSortedList($container);
            $list.find('>*').detach();
            $list.append($(sortedBoxes));
        }
        var currentCount = 0;
        $container.find(sel).each(function (i, img) {
            var $img = $(img);
            var $box = sel === 'img.asset' ? $img.closest('.asset-box') : $img;
            var assetId = getAssetId($img);
            var show = assetIds[assetId];
            if (show) {
                $box.show();
                currentCount++;
            }
            else {
                $box.hide();
            }
        });
        return currentCount;
    }
    exports.applyAssetFilters = applyAssetFilters;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/assetFilter.js
// module id = 24
// module chunks = 0